/*
 * @Author: wyh
 * @Date: 2017-10-31 15:10:50
 * @Last Modified by: wyh
 * @Last Modified time: 2019-09-26 22:23:58
 * @Description: 工具类
 */

import { Injectable } from "@angular/core";
import { ModalController } from "ionic-angular";
import { DataSourceKeyObj } from "../../pages/common/general-detail/generalDetail.modal";
import { CalendarModal } from "../../shared/calendar/calendar.modal";
import * as lodash from "lodash";

const emojiReg =
  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;

const autoPages = [
  {
    id: "10",
    root: "BasicInfoPage",
    px: 1,
    dataSourceKey: DataSourceKeyObj.j,
    rootParams: { datas: {} },
    title: "COMMON.GEN_BASWINFO",
  }, //基本信息
  {
    id: "20",
    root: "ExpenseDetailPage",
    px: 2,
    dataSourceKey: DataSourceKeyObj.m,
    rootParams: { datas: {} },
    title: "COMMON.GEN_DETAILINFO",
  }, //明细-对公
  {
    id: "21",
    root: "ExpenseDetailPage",
    px: 2,
    dataSourceKey: DataSourceKeyObj.m,
    rootParams: { datas: {} },
    title: "COMMON.GEN_DETAILINFO",
  }, //明细-对私
  {
    id: "40",
    root: "HexiaoInfoPage",
    px: 3,
    dataSourceKey: DataSourceKeyObj.h,
    rootParams: { datas: {} },
    title: "COMMON.GEN_HEXIAOINFO",
  }, //核销
  {
    id: "90",
    root: "PaymentInfoPage",
    px: 7,
    dataSourceKey: DataSourceKeyObj.z,
    rootParams: { datas: {} },
    title: "COMMON.GEN_ZHIFUINFO",
  }, //支付
];

const autoHidePages = [
  {
    id: "703",
    root: "BudgetDetailPage",
    px: 1.2,
    dataSourceKey: DataSourceKeyObj.bd,
    rootParams: { datas: {} },
    title: "COMMON.GEN_BUDGGETINFO",
  }, //预算明细
  {
    id: "30",
    root: "InvoiceDetailPage",
    px: 5,
    dataSourceKey: DataSourceKeyObj.f,
    rootParams: { datas: {} },
    title: "COMMON.GEN_FAPIAOINFO",
  }, //发票
  {
    id: "50",
    root: "YakuanInfoPage",
    px: 6,
    dataSourceKey: DataSourceKeyObj.y,
    rootParams: { datas: {} },
    title: "COMMON.GEN_YALKUAN",
  }, //押款
  {
    id: "60",
    root: "KoukuanInfoPage",
    px: 4,
    dataSourceKey: DataSourceKeyObj.k,
    rootParams: { datas: {} },
    title: "COMMON.GEN_KOUKUAN",
  }, //扣款
  {
    id: "99",
    root: "FentanInfoPage",
    px: 8,
    dataSourceKey: DataSourceKeyObj.ft,
    rootParams: { datas: {} },
    title: "COMMON.GEN_FENTANINFO",
  }, //分摊
  {
    id: "21",
    root: "TafangInfoPage",
    px: 6.5,
    dataSourceKey: DataSourceKeyObj.tf,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TFCD",
  }, //他方承担 对公
  {
    id: "202001",
    root: "TrafficInfoPage",
    px: 11,
    dataSourceKey: DataSourceKeyObj.jp,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TR_TRAFFIC",
  }, //机票 海信
  {
    id: "202002",
    root: "HotelInfoPage",
    px: 13,
    dataSourceKey: DataSourceKeyObj.jd,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TR_HOTEL",
  }, //酒店 海信
  {
    id: "202003",
    root: "RentcarInfoPage",
    px: 15,
    dataSourceKey: DataSourceKeyObj.zc,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TR_RENT",
  }, //租车 海信
  {
    id: "202004",
    root: "OtherInfoPage",
    px: 16,
    dataSourceKey: DataSourceKeyObj.qt,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TR_OTHER",
  }, //其它 海信
  {
    id: "23",
    root: "TafangSfInfoPage",
    px: 6.5,
    dataSourceKey: DataSourceKeyObj.tfsf,
    rootParams: { datas: {} },
    title: "COMMON.GEN_TFCD",
  }, //他方承担 盛丰
];
//对私所有单据
const persionalArr = ["10", "11", "20", "15", "21", "40", "41", "618"];

//无明细信息单据类型
const _noBase: Array<any> = ["40", "41", "90", "93"];
//无核销单据类型
const _noHexiao: Array<any> = [
  "50",
  "51",
  "40",
  "90",
  "202",
  "20201",
  "20202",
  "401",
  "421",
  "411",
  "301",
  "321",
  "311",
  "101",
  "111",
  "112",
  "700",
  "701",
  "703",
  "705",
  "704",
];
//无支付信息单据类型
const _noPayment: Array<any> = [
  "93",
  "41",
  "202",
  "20201",
  "20202",
  "401",
  "421",
  "411",
  "301",
  "321",
  "311",
  "101",
  "111",
  "112",
  "700",
  "701",
  "703",
  "705",
  "704",
];

//默认隐藏的有 分摊明细
const _hasFentan: Array<any> = ["401", "411", "421", "60"];

//不在此范围内的统一使用对公通用报账来展示
// const _guoxinHas: Array<any> = ['50', '51', '10', '20', '21', '30', '40', '41', '90', '60', '202', '401', '89', '15', '421', '411', '301', '311', '321', '101', '111', '112'];

@Injectable()
export class Utils {
  constructor(private modalCtrl: ModalController) {}

  private get autoPages() {
    return autoPages.slice(0);
  }

  private get autoHidePages() {
    return autoHidePages.slice(0);
  }

  public usAp(claimType) {
    const use = [10, 12, 15, 20, 21, 30, 34, 55, 60, 88, 89, 90, 618];
    return use.indexOf(claimType) > 0;
  }

  public isUsedClaim(claimType) {
    // if (_guoxinHas.indexOf(claimType) == -1) {
    //     return 'nomal';
    // } else {
    //     return claimType
    // }
    return claimType;
  }

  /**
   * 将文本中的表情用emoji替代
   * @param text 目标文本
   */
  public operateEmoji(text: string): string {
    let hasEmo = emojiReg.test(text);
    if (hasEmo) return text.replace(emojiReg, "emoji");
    return text;
  }

  /**
   * 判断是否为对公单据
   * @param docTypeCode 单据类型
   */
  public isPubilcDoc(docTypeCode): boolean {
    if (persionalArr.toString().includes(docTypeCode)) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * 初始化自动页面
   * @param docTypeCode 单据类型
   */
  private initAutoPages(initPage, docTypeCode) {
    if (_noPayment.indexOf(docTypeCode) != -1) {
      initPage.splice(3, 1);
    }
    // if (_noInvoice.indexOf(docTypeCode) != -1) {
    //     initPage.splice(4, 1);
    // };
    if (_noHexiao.indexOf(docTypeCode) != -1) {
      initPage.splice(2, 1);
    }
    if (_noBase.indexOf(docTypeCode) != -1) {
      initPage.splice(1, 1);
    }
    if (_hasFentan.indexOf(docTypeCode) != -1) {
      initPage.push(autoHidePages[4]);
    }
    switch (docTypeCode) {
      //出差申请 出差信息
      case "202":
      case "20201":
      case "20202":
        initPage[0].title = "COMMON.GEN_TR_BASE";
        initPage[1].title = "COMMON.GEN_TR_TRAVEL";
        initPage[2] = {
          id: "20",
          root: "TravelPlanPage",
          px: 3,
          dataSourceKey: DataSourceKeyObj.r,
          rootParams: { datas: {} },
          title: "COMMON.PLAN_DETAIL",
        };
        // initPage.push(...this.autoHidePages.slice(6, 10));
        break;
      case "711":
      case "713":
      case "714":
      case "715":
      case "716":
      case "717":
      case "718":
        initPage[1].title = "COMMON.GEN_ADJUSTINFO";
        break;
      case "703":
      case "704":
      case "705":
      case "701":
        initPage[1].title = "COMMON.GEN_BUDGGETINFO";
        break;
      default:
        break;
    }
    return initPage;
  }

  /**
   * 根据动态字段初始化动态页面
   * @param docTypeCode 单据类型
   * @param autoFields 动态页面
   * @param fieldParams 传给各个动态页面的详情数据
   */
  public autoFieldsToPage(
    docTypeCode,
    autoFields,
    fieldParams,
    publicParams = {}
  ) {
    if (!autoFields || autoFields == null) autoFields = {};
    const aupage = JSON.parse(JSON.stringify(this.autoPages));
    // if (this.isPubilcDoc(docTypeCode)) {
    //     aupage.splice(2, 1)
    // } else {
    //     aupage.splice(1, 1)
    // }
    aupage.splice(1, 1);
    let newAutoPages = this.initAutoPages(aupage, docTypeCode).filter(
      (page) => {
        const taPage = autoFields[page.id]; //所有动态字段
        const taTem = taPage ? taPage[page.id] : undefined; //控制当前区域动态字段
        // if (taTem && taTem.isDisplayFlag == '0') {
        //     return false;
        // };
        if (taPage) {
          // taTem && taTem.fieldName && (page.title = taTem.fieldName);
          page.rootParams["baseFields"] = taPage;
        }
        page.rootParams = { ...page.rootParams, ...publicParams };
        page.rootParams.datas = fieldParams[page.dataSourceKey];
        return true;
      }
    );
    //默认隐藏的区域
    this.autoHidePages.forEach((el) => {
      if (el.id == "21" && newAutoPages.some((a) => a.id == "21")) {
        //对私的情况下 不考虑隐藏区域的21 他方承担
      } else {
        const taPage = autoFields[el.id]; //所有动态字段
        if (taPage) {
          const taTem = taPage[el.id] || {};
          if (taTem.isDisplayFlag == "1") {
            taTem.fieldName && (el.title = taTem.fieldName);
            el.rootParams["baseFields"] = taPage;
            el.rootParams = { ...el.rootParams, ...publicParams };
            el.rootParams.datas = fieldParams[el.dataSourceKey];
            newAutoPages.push(el);
          }
        }
      }
    });
    newAutoPages = lodash.sortBy(newAutoPages, (pa) => pa.px);
    console.log(newAutoPages);
    return newAutoPages;
  }

  /**
   *  比较两个json对象是否相同
   */
  public Compare(objA, objB) {
    if (!this.isObj(objA) || !this.isObj(objB)) return false; //判断类型是否正确
    if (this.getLength(objA) != this.getLength(objB)) return false; //判断长度是否一致
    return this.CompareObj(objA, objB, true); //默认为true
  }

  private CompareObj(objA, objB, flag) {
    for (var key in objA) {
      if (!flag)
        //跳出整个循环
        break;
      if (!objB.hasOwnProperty(key)) {
        flag = false;
        break;
      }
      if (!this.isArray(objA[key])) {
        //子级不是数组时,比较属性值
        if (objB[key] != objA[key]) {
          flag = false;
          break;
        }
      } else {
        if (!this.isArray(objB[key])) {
          flag = false;
          break;
        }
        var oA = objA[key],
          oB = objB[key];
        if (oA.length != oB.length) {
          flag = false;
          break;
        }
        for (var k in oA) {
          if (!flag)
            //这里跳出循环是为了不让递归继续
            break;
          flag = this.CompareObj(oA[k], oB[k], flag);
        }
      }
    }
    return flag;
  }

  private isObj(object) {
    return (
      object &&
      typeof object == "object" &&
      Object.prototype.toString.call(object).toLowerCase() == "[object object]"
    );
  }

  private isArray(object) {
    return object && typeof object == "object" && object.constructor == Array;
  }

  private getLength(object) {
    var count = 0;
    for (var i in object) count++;
    return count;
  }

  /**
   * arr=>树结构
   * @param list
   * @param rootParentId
   */
  public listToTree(list, rootParentId = "-1") {
    try {
      if (list && list.length) {
        let root = { id: rootParentId, parentId: null, children: [] };
        const group = {};
        for (let index = 0; index < list.length; index += 1) {
          if (list[index].id == rootParentId)
            root = { ...list[index], ...root };
          if (
            list[index].parentId !== null &&
            list[index].parentId !== undefined
          ) {
            if (!group[list[index].parentId]) {
              group[list[index].parentId] = [];
            }
            group[list[index].parentId].push(list[index]);
          }
        }
        const queue = [];
        queue.push(root);
        while (queue.length) {
          const node = queue.shift();
          node.children =
            group[node.id] && group[node.id].length ? group[node.id] : null;
          if (node.children) {
            queue.push(...node.children);
          }
        }
        return root;
      }
    } catch (error) {
      return false;
    }
  }

  /**
   * arr=>树结构,地区
   * @param list
   * @param rootParentId
   */
  public listToTreeForCountry(list, rootParentId) {
    try {
      if (list && list.length) {
        let parentId = rootParentId instanceof Array ? "-1" : rootParentId;
        let root = { id: parentId, parentId: null, children: [] };
        const group = {};
        for (let index = 0; index < list.length; index += 1) {
          if (list[index].id == parentId) root = { ...list[index], ...root };
          if (
            list[index].parentId !== null &&
            list[index].parentId !== undefined
          ) {
            if (!group[list[index].parentId]) {
              group[list[index].parentId] = [];
            }
            group[list[index].parentId].push(list[index]);
          }
        }
        const queue = [];
        queue.push(root);
        while (queue.length) {
          const node = queue.shift();
          node.children =
            group[node.id] && group[node.id].length ? group[node.id] : null;
          if (node.children) {
            queue.push(...node.children);
          }
        }
        if (rootParentId instanceof Array) {
          let id = 0;
          if (rootParentId.indexOf("10") == -1) {
            id = 10;
          } else if (rootParentId.indexOf("20") == -1) {
            id = 20;
          } else if (rootParentId.indexOf("30") == -1) {
            id = 30;
          }
          let result = root.children.filter((item) => item.id != id);
          root.children = result;
        }
        return root;
      }
    } catch (error) {
      return false;
    }
  }

  /**
   * 树结构=>arr
   */
  public treeConvertList(root) {
    const list = [];
    root.forEach((r) => {
      const Root = JSON.parse(JSON.stringify(r));
      const queue = [];
      queue.push(Root);
      while (queue.length) {
        const node = queue.shift();
        if (node.children && node.children.length) {
          queue.push(...node.children);
        }
        delete node.children;
        if (node.parentId !== null && node.parentId !== undefined) {
          list.push(node);
        }
      }
    });
    return list;
  }

  /**
   * 获取地址栏url参数
   */
  public getUrlParams(): any {
    let result;
    // const hashUrl = window.location.hash;
    //http://leon2020.vipgz1.idcfengye.com/?pageName=ApprovalPage&code=ys3wtLCoe-C487nfKihFQCcRXTeGjTTN34HCtgEzoqg&state=WeChat
    const hashUrl = window.location.href;
    console.log("-------------" + hashUrl);
    const cutIndex = hashUrl.indexOf("?");
    if (cutIndex != -1) {
      // const pg = hashUrl.substring(cutIndex + 1);
      // const pgArr = pg.split("/");
      // console.log(pgArr);
      const str = hashUrl.substr(cutIndex + 1);
      const par = str.split("&");
      const params = new Object();
      console.log(par);
      for (var i = 0; i < par.length; i++) {
        params[par[i].split("=")[0]] = par[i].split("=")[1];
      }
      console.log(params);
      result = {
        page: params["redirectPage"],
        params,
      };
      return result;
    } else {
      //没带参数默认为非指定跳转
      console.log("there is no params on the end of url!");
      return false;
    }
  }

  /**
   * 打开日历
   */
  public calendar(calendarOpn = {}): any {
    // let dates = new Date();
    // if (defaultDate) {
    //     let formateDate = defaultDate.split('-');
    //     dates = new Date(parseInt(formateDate[0]), parseInt(formateDate[1]) - 1, parseInt(formateDate[2]))
    // }

    let _daysConfig = [];
    const options = {
      pickMode: "single", // single:单选日期， range: 连选日期（用于住宿等）
      // closeLabel: this.COMMON_MSG.BUTTON.CLOSE,
      // doneLabel: this.COMMON_MSG.BUTTON.FINISH,
      // from: new Date(),
      // to: new Date(),
      defaultScrollTo: new Date(),
      // defaultDate: new Date(),
      monthFormat: "yyyy 年 MM 月 ",
      title: "",
      closeIcon: true,
      autoDone: true,
      daysConfig: _daysConfig,
      ...calendarOpn,
    };
    //配置参数
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: options,
    });

    //日期初始化
    return myCalendar;
  }

  public resolveNum(numObj): any {
    const rObj = {};
    Object.keys(numObj).forEach((k) => {
      try {
        if (typeof numObj != "number") {
          rObj[k] = Number.parseFloat(numObj[k]);
        }
      } catch (e) {
        rObj[k] = 0;
      }
      if (Number.isNaN(rObj[k])) {
        rObj[k] = 0;
      }
    });
    return rObj;
  }

  public toNum(data) {
    try {
      if (typeof data != "number") {
        data = Number.parseFloat(data);
      }
    } catch (e) {
      data = 0;
    }
    if (Number.isNaN(data)) {
      data = 0;
    }
    return data;
  }

  /**
   * 明细 按税率计算不含税金额 可抵扣税额 含税金额等
   * @param {*} calcObj 包含所有需要计算的值
   * @param {*} key 动态改变的值，通过该值计算其他
   * @param {*} changeValue false 可输入文本（含税金额、不含税金额只能有一个可以输入）默认含税金额
   * 税率：vatRate, 含税金额：expenseAmt, 可抵扣税额：vatDeductAmt, 不可抵扣额：vatNoDeductAmt, 不含税金额：netAmt, 税额：vatAmt,
   */
  public calcWithRate(calcObj, key, changeValue = false) {
    const {
      vatRate = 0,
      expenseAmt = 0,
      vatDeductAmt = 0,
      vatNoDeductAmt = 0,
      netAmt = 0,
      vatAmt = 0,
    } = calcObj;
    const _nums = this.resolveNum({
      vatRate,
      expenseAmt,
      vatDeductAmt,
      vatNoDeductAmt,
      netAmt,
      vatAmt,
    });
    const res = lodash.cloneDeep(_nums);
    const calcOne = () => {
      //计算不含税
      res.vatAmt = lodash.round(
        (_nums.expenseAmt / (1 + _nums.vatRate)) * _nums.vatRate,
        2
      ); //calc 税额
      res.vatDeductAmt = res.vatAmt - res.vatNoDeductAmt; // //calc 可抵扣税额
      res.netAmt = lodash.round(_nums.expenseAmt - res.vatAmt, 2); //calc 不含税金额
    };
    const calcTwo = () => {
      //计算含税
      res.vatAmt = lodash.round(_nums.netAmt * _nums.vatRate, 2); //calc 税额
      res.expenseAmt = lodash.round(_nums.netAmt + res.vatAmt, 2); //calc 含税金额
      res.vatDeductAmt = lodash.round(res.vatAmt - _nums.vatNoDeductAmt, 2); //calc 可抵扣税额
    };
    switch (key) {
      //含税金额改变
      case "expenseAmt":
        calcOne();
        break;
      //不含税金额改变
      case "netAmt":
        calcTwo();
        break;
      //可抵扣税额改变
      case "vatDeductAmt":
        if (changeValue) {
          //不含税金额作为输入
          res.vatAmt = _nums.vatDeductAmt + _nums.vatNoDeductAmt; //calc 税额
          res.expenseAmt = lodash.round(_nums.netAmt + res.vatAmt, 2); //calc 含税金额
        } else {
          res.vatAmt = _nums.vatDeductAmt + _nums.vatNoDeductAmt; //calc 税额
          res.netAmt = lodash.round(_nums.expenseAmt - res.vatAmt, 2); //calc 不含税金额
        }
        break;
      //不可抵扣税额改变
      case "vatNoDeductAmt":
        if (changeValue) {
          //不含税金额作为输入
          res.vatAmt = _nums.vatDeductAmt + _nums.vatNoDeductAmt; //calc 税额
          res.expenseAmt = lodash.round(_nums.netAmt + res.vatAmt, 2); //calc 含税金额
        } else {
          res.vatAmt = _nums.vatDeductAmt + _nums.vatNoDeductAmt; //calc 税额
          res.netAmt = lodash.round(_nums.expenseAmt - res.vatAmt, 2); //calc 不含税金额
        }
        break;
      //默认为 税码 税率改变，其他变更有可能导致税率改变 所以不在指定值变化的范围内则默认按税率计算
      default:
        if (changeValue) {
          //不含税金额作为输入
          calcTwo();
        } else {
          calcOne();
        }
        break;
    }
    res["plAmt"] = res.netAmt + res.vatNoDeductAmt; //calc 申请金额
    return res;
  }

  /**
   * 对金额进行格式化，返回格式化之后的金额
   * @param s：金额
   * @param type：金额后面保留几位小数
   * @returns {any}
   */
  public formatMoney(s, type = 2) {
    if (/[^0-9\.]/.test(s)) return "0";
    if (s == null || s == "") return "0";
    s = s.toString().replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s)) s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    if (type == 0) {
      // 不带小数位(默认是有小数位)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    return s * 1;
  }

  /**
   * name fieldKey date: false  money:false
   * @param arr
   */
  templateInit(arr, labelObj) {
    let template = "";
    arr.forEach((el) => {
      let pipe = "";
      let classs = "";
      let hidden = "";
      if (el.date) pipe = "| date:'yyyy-MM-dd'";
      if (el.money) {
        classs = 'class="money"';
        pipe = "| forMoney:''";
      }
      if (el.hidden) hidden = "hidden=true";
      let label = "没找到";
      Object.keys(labelObj).forEach((key) => {
        if (el.name === labelObj[key]) {
          label = key;
        }
      });
      template += `<!--${el.name} -->
        <read-item [fields]="baseFields" fieldKey="${el.fieldKey}" label="FORM.LABEL.${label}" ${hidden} ${classs}>
            {{dataDetail.${el.fieldKey} ${pipe}}}
        </read-item>`;
    });
    return template;
  }

  /**
   * 去除对象无用属性
   * @param data
   */
  simpleObj(data) {
    const nObj = {};
    for (const key in data) {
      if (data[key] != null && data[key] != undefined && data[key] !== "") {
        nObj[key] = data[key];
      }
    }
    return nObj;
  }

  // 精确加法
  plus(num1, num2) {
    const baseNum = Math.pow(
      10,
      Math.max(this.digitLength(num1), this.digitLength(num2))
    );
    return (this.times(num1, baseNum) + this.times(num2, baseNum)) / baseNum;
  }

  // 获取当前数小数位的长度(处理科学计数法，本质上处理e-n的情况)
  digitLength(num) {
    const eSplit = num.toString().split(/[eE]/);
    const len = (eSplit[0].split(".")[1] || "").length - (+eSplit[1] || 0);
    return len > 0 ? len : 0;
  }

  // 乘法
  times(num1, num2) {
    const num1Changed = this.float2Fixed(num1);
    const num2Changed = this.float2Fixed(num2);
    // 把两个数的小数位数相加
    const baseNum = this.digitLength(num1) + this.digitLength(num2);
    const leftValue = num1Changed * num2Changed;
    return leftValue / Math.pow(10, baseNum);
  }

  // 把小数转成整数，支持科学计数法。如果是小数则放大成整数
  float2Fixed(num) {
    if (~num.toString().indexOf("e")) {
      return Number(num.toString().replace(".", ""));
    }
    const dlen = this.digitLength(num);
    return dlen > 0 ? Math.round(num * Math.pow(10, dlen)) : num;
  }

  // 精确减法
  minus(num1, num2): number {
    const baseNum = Math.pow(
      10,
      Math.max(this.digitLength(num1), this.digitLength(num2))
    );
    return (this.times(num1, baseNum) - this.times(num2, baseNum)) / baseNum;
  }

  /**
   * 获取年月日
   * @param date 时间戳
   */
  getStringDate(date) {
    const da = new Date(date);
    let month: any = da.getMonth() + 1;
    if (month < 10) month = "0" + month;
    let result = [da.getFullYear(), month, da.getDate()];
    return result;
  }

  /**
   * 获取两个日期之间的所有日期
   * @param startTime 开始日期
   * @param endTime 结束日期
   * @param self 是否包含开始结束日期
   */
  getDatesBetween(startTime, endTime, self = true) {
    let timeStamp = Math.ceil(
      (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60 * 24)
    ); //判断两个日期相差多少天
    let timeArr = self ? [new Date(startTime.getTime())] : [];
    const ai = self ? 1 : 0;
    for (let index = 1; index < timeStamp + ai; index++) {
      const element = startTime.setTime(
        1000 * 60 * 60 * 24 + startTime.getTime()
      );
      timeArr.push(new Date(element));
    }
    return timeArr;
  }

  //多数加法或减法
  calcArr(arr: Array<number>, type?) {
    let res = 0;
    for (let i = 0; i < arr.length; i++) {
      if (type == "minus") {
        if (i == 0) {
          res = arr[i];
          continue;
        }
        res = this.minus(res, arr[i]);
      } else {
        res = this.plus(res, arr[i]);
      }
    }
    return res;
  }
}



// WEBPACK FOOTER //
// ./src/services/common/utils.ts